import { Component, OnInit } from '@angular/core';
import { ActiveModal } from '@healthcatalyst/cashmere';
import { take } from 'rxjs';
import { ApiInfoService } from '../core/services/application/api-info.service';
import { ToastNotificationService } from '../core/services/toast-notification.service';
import { ApiInfo } from '../shared/models/api-info';
import { environment } from 'src/environments/environment';

@Component({
    templateUrl: 'about-modal.component.html',
    styleUrls: ['about-modal.component.scss'],
    standalone: false
})
export class AboutModalComponent implements OnInit {
    version = environment.versionNumber;
    environmentName = environment.environmentName;
    apiVersion: string;
    loadingVersion: boolean;

    constructor(
        public activeModal: ActiveModal,
        private apiInfoService: ApiInfoService,
        private toastNotificationService: ToastNotificationService
    ) {}

    ngOnInit() {
        this.loadVersion();
    }

    close(): void {
        this.activeModal.close();
    }

    private loadVersion(): void {
        this.loadingVersion = true;

        this.apiInfoService
            .getApiInfo()
            .pipe(take(1))
            .subscribe({
                next: (apiInfo: ApiInfo) => {
                    this.apiVersion = apiInfo.apiVersion;
                    this.loadingVersion = false;
                },
                error: () => {
                    this.toastNotificationService.showError('Unable to retrieve application version.');
                    this.loadingVersion = false;
                }
            });
    }
}
